// extracted by mini-css-extract-plugin
module.exports = {"emptyPlayer":"styles_emptyPlayer__GIx00","waitForPlayers":"styles_waitForPlayers__R_bm2"};